export default __webpack_public_path__ + "static/media/2155.8975980c.png";